import {
  detectBrowserTimeSettings,
  withBrowserTimeSettings,
} from "@/legacy/utils/browserTimeSettings";
import { Controller } from "@hotwired/stimulus";

// Reports the browser's timezone and clock at web sign-up: fills the
// registration form's hidden fields and adds both to the SSO button URLs
// inside this element. See User.browser_time_settings.
export default class extends Controller<HTMLElement> {
  static targets = ["timezone", "timeFormat"];

  declare readonly hasTimezoneTarget: boolean;
  declare readonly timezoneTarget: HTMLInputElement;
  declare readonly hasTimeFormatTarget: boolean;
  declare readonly timeFormatTarget: HTMLInputElement;

  connect(): void {
    const settings = detectBrowserTimeSettings();

    if (this.hasTimezoneTarget) this.timezoneTarget.value = settings.timezone;
    if (this.hasTimeFormatTarget) {
      this.timeFormatTarget.value = settings.timeFormat;
    }

    this.element
      .querySelectorAll<HTMLFormElement>('form[action*="/users/auth/"]')
      .forEach((form) => {
        const action = form.getAttribute("action");
        if (action) {
          form.setAttribute(
            "action",
            withBrowserTimeSettings(action, settings)
          );
        }
      });
  }
}
